import {h, Component} from 'preact';
import {observer} from "mobx-preact";
import {copyToClipboard} from "../utils/Common";
import {setCookie} from "../utils/Cookie";

@observer
class WinPage extends Component {
    constructor(props) {
        super(props);
        this.winPageStore = props.winPageStore;
        this.appStore = props.appStore;
        this.campaignStore = props.campaignStore;
        if (props.isAdminComponent) {
            window.getWinPageCampaignData = this.campaignStore.getCampaignFromJson;
            const eventTriggerLoaded = new Event('winPageLoaded');
            document.dispatchEvent(eventTriggerLoaded);
        }
    }

    componentDidMount(){
        this.campaignStore.setPopUpColors(this.popUp);
        // TODO Перед деплоем поправить
        if (true){
            setCookie('wheel_app_hide', 'true', this.campaignStore.submitFormExpirationDays);
        }
        setCookie('kol_wheel_app_show_scarcity', Date.now(), 1);
        setCookie('kol_wheel_scarcity_coupon_code', this.winPageStore.couponCode, 1);
    }

    copyCode = event => {
        event.preventDefault();
        copyToClipboard(this.winPageStore.couponCode);
        this.appStore.hideApp();
    };
    getWinPageThemeClass(){
        return `kol-win-page-theme-${this.campaignStore.formTheme}`;
    }

    render() {
        const {title} = this.winPageStore;
        const winPageThemeClass = this.getWinPageThemeClass();

        return <form id="kol-popup" ref={popUp => this.popUp = popUp} className={`${winPageThemeClass}`}>
            <div className="kol-popup__header">
                <h5 className="kol-popup__title">
                    {title}
                </h5>
                <button className="kol-button kol-popup__close" onClick={this.appStore.hideApp}>
                    <svg width="16" height="16">
                        <path
                            d="M15.35 14.65a.48.48 0 0 1 0 .7.48.48 0 0 1-.7 0L8 8.71l-6.65 6.64a.47.47 0 0 1-.35.15.47.47 0 0 1-.35-.15.48.48 0 0 1 0-.7L7.29 8 .65 1.35a.48.48 0 0 1 0-.7.48.48 0 0 1 .7 0L8 7.29 14.65.65a.48.48 0 0 1 .7 0 .48.48 0 0 1 0 .7L8.71 8z"/>
                    </svg>
                </button>
            </div>
            <div className="kol-thankyou">
                <p className="kol-thankyou__wintext mb-2em"
                   dangerouslySetInnerHTML={{__html: this.winPageStore.text}}/>
                <dl className="kol-thankyou__card">
                    <dt className="kol-thankyou__key mb-05em">{this.winPageStore.couponCodeTitle}</dt>
                    <dd className="kol-thankyou__value">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#dedede" width="10" height="40">
                            <path d="M8.84 0A8.732 8.732 0 0 0 0 8.6v5.7a1 1 0 0 0 1 1 4.704 4.704 0 1 1 0 9.4 1 1 0 0 0-1 1v5.7A8.732 8.732 0 0 0 8.84 40H10V0z"/>
                        </svg>
                        <span>{this.winPageStore.couponCode}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#dedede" width="10" height="40">
                            <path d="M9 15.3a1 1 0 0 0 1-1V8.6A8.732 8.732 0 0 0 1.16 0H0v40h1.16A8.732 8.732 0 0 0 10 31.4v-5.7a1 1 0 0 0-1-1 4.704 4.704 0 1 1 0-9.4z"/>
                        </svg>
                    </dd>
                </dl>
                <button className="kol-button kol-thankyou__copy" onClick={this.copyCode}>
                    {this.winPageStore.buttonLabel}
                </button>
            </div>
        </form>
    }
}

export default WinPage;
